import React from 'react'
import { useNavigate } from 'react-router-dom'
import AppFormFooterBar from '../../../components/AppFormFooterBar'
import useNoticeEntry from './hooks/useNoticeEntry'

export default function NoticeEntryScreen() {
  const navigate = useNavigate()
  const { state, actions } = useNoticeEntry()

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-28">
      {/* ── Header ── */}
      <section className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">
            Cloud &amp; Communication
          </p>
          <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight text-on-surface">
            {state.isEditMode ? 'Edit Notice' : 'Add Notice'}
          </h1>
        </div>

      </section>

      {/* ── Notice Panel ── */}
      <div className="rounded-3xl border border-outline-variant/25 bg-surface-container-lowest p-6 sm:p-8 shadow-xs">
        <div className="flex items-center gap-2 text-primary font-bold text-sm border-b border-outline-variant/15 pb-4 mb-6">
          <span className="material-symbols-outlined text-base">campaign</span>
          <span>Notice</span>
        </div>

        <div>
          <label className="text-xs font-black uppercase tracking-wider text-on-surface-variant block mb-2">
            Notice Text <span className="text-rose-500">*</span>
          </label>
          <textarea
            rows={10}
            placeholder="Enter notice text here..."
            value={state.notice}
            onChange={(e) => actions.setNotice(e.target.value)}
            className="w-full min-h-[250px] rounded-2xl border border-outline-variant/30 bg-surface-container-low p-4 text-xs text-on-surface outline-none focus:border-primary resize-y leading-relaxed"
          />
        </div>
      </div>

      {/* ── Bottom Fixed Save Bar ── */}
      <AppFormFooterBar
        onSave={actions.handleSave}
        onCancel={() => navigate('/cloud/notice/list')}
        isSaving={state.isSaving}
        saveText="Save &amp; Exit"
        cancelText="Cancel"
      />
    </div>
  )
}
